import { RangeSelection } from 'lexical';

/**
 * Get the selected node from a range selection
 * Follows Lexical playground patterns
 */
export function getSelectedNode(selection: RangeSelection) {
  const anchor = selection.anchor;
  const focus = selection.focus;
  const anchorNode = selection.anchor.getNode();
  const focusNode = selection.focus.getNode();

  if (anchorNode === focusNode) {
    return anchorNode;
  }

  const isBackward = selection.isBackward();
  if (isBackward) {
    return anchor.isBefore(focus) ? anchorNode : focusNode;
  } else {
    return anchor.isBefore(focus) ? focusNode : anchorNode;
  }
}
